import React, { useState } from "react";
import styled from "styled-components";
import { Body3 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";
import { CheckBoxButton } from "../../../../assets/styles/InputStyle";

// 이미지 import 추가
import DesignMordenBoard from "../../../../assets/images/Design_mordenboard.png";
import DesignSimpleFlow from "../../../../assets/images/Design_simpleflow.png";
import DesignConceptRed from "../../../../assets/images/Design_Concept_Red.png";

import B_style_1 from "../../../../assets/images/Background/B_peach_bloom.png";
import B_style_2 from "../../../../assets/images/Background/B_lavender_cream.png";
import B_style_3 from "../../../../assets/images/Background/B_mint_breeze.png";
import B_style_4 from "../../../../assets/images/Background/B_yellow_moment.png";
import B_style_5 from "../../../../assets/images/Background/B_classic_bronze.png";
import B_style_6 from "../../../../assets/images/Background/B_retro_blue.png";
import B_style_7 from "../../../../assets/images/Background/B_modern_edge.png";
import B_style_8 from "../../../../assets/images/Background/B_tech_black.png";
import B_style_9 from "../../../../assets/images/Background/B_fresh_navy.png";
import Info_background from "../../../../assets/images/Background/Info_background.png";
import OrganismDisplayViewInfoPreview from "../../../Global/components/organisms/OrganismDisplayViewInfoPreview";
import logo from "../../../../assets/images/penLogo.png";

const OrganismDesignConceptSelector = ({
  concepts = [],
  selectedConcepts = [],
  onSelect,
  disabled = false,
  titleData,
  markdownData,
  contentsType,
  linkUrl,
}) => {
  const [previewConcept, setPreviewConcept] = useState(null);

  const isSelected = (conceptId) => {
    return selectedConcepts.includes(conceptId);
  };

  const isDisabled = (concept) => {
    return (
      disabled ||
      // concept.name === "기본 심플형" ||
      concept.name === "어두운 기본형"
    );
  };

  const handleToggle = (conceptId, fromCheckbox = false) => {
    // if (!isDisabled(concepts.find(c => c.id === conceptId))) {
    onSelect(conceptId);
    // }
  };

  const handlePreview = (concept, e) => {
    e.stopPropagation();
    setPreviewConcept(concept);
  };

  const handleClosePreview = () => {
    setPreviewConcept(null);
  };

  // 컨셉트별 이미지를 반환하는 함수
  const getPreviewImage = (conceptName) => {
    switch (conceptName) {
      case "concept1":
        return Info_background;
      case "concept2":
        return B_style_2;
      case "concept3":
        return B_style_3;
      case "concept4":
        return B_style_4;
      case "concept5":
        return B_style_5;
      case "concept6":
        return B_style_6;
      case "concept7":
        return B_style_7;
      case "concept8":
        return B_style_8;
      case "concept9":
        return B_style_9;
      default:
        return Info_background;
    }
  };

  // // 컨셉트별 네이밍을 반환하는 함수
  // const getConceptName = (conceptId) => {
  //   switch (conceptId) {
  //     case "concept1":
  //       return "피치 블룸";
  //     case "concept2":
  //       return "라벤더 크림";
  //     case "concept3":
  //       return "민트 브리즈";
  //     case "concept4":
  //       return "옐로우 모먼트";
  //     case "concept5":
  //       return "클래식 브론즈";
  //     case "concept6":
  //       return "레트로 블루";
  //     case "concept7":
  //       return "모던 엣지";
  //     case "concept8":
  //       return "테크 블랙";
  //     case "concept9":
  //       return "프레시 네이비";
  //     default:
  //       return "기본 테마";
  //   }
  // };

   // 컨셉트별 네이밍을 반환하는 함수
  const getConceptName = (conceptId) => {
    switch (conceptId) {
      case "concept1":
        return "기본 테마";
     
      default:
        return "기본 테마";
    }
  };
  return (
    <ConceptSelectorWrapper>
      <ConceptGrid>
        {concepts.map((concept) => (
          <ConceptCard
            key={concept.id}
            selected={isSelected(concept.id)}
            // disabled={isDisabled(concept)}
            onClick={(e) => {
              // 체크박스에서 온 클릭이 아닐 때만 실행
              if (e.target.type !== "checkbox") {
                handleToggle(concept.id);
              }
            }}
          >
            <ConceptHeader>
              <LeftAlignedCheckBox
                id={concept.id}
                name={concept.id}
                checked={isSelected(concept.id)}
                onChange={() => handleToggle(concept.id, true)}
                // disabled={isDisabled(concept)}
              />
              <ConceptName>{getConceptName(concept.id)}</ConceptName>
            </ConceptHeader>
            <ConceptPreview>
              <PreviewImage
                src={getPreviewImage(concept.id)}
                alt={concept.name}
              />
              <PreviewOverlay>
                <PreviewButton onClick={(e) => handlePreview(concept, e)}>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.4982 5.97656C17.0176 5.97656 21.0841 8.45875 22.3546 11.834C22.479 12.1648 22.497 12.5362 22.3849 12.8906C21.61 15.3386 18.5559 18.5762 12.4982 18.5762C6.4168 18.576 3.42075 15.0231 2.63488 12.918C2.50683 12.5749 2.50547 12.2079 2.61144 11.875C3.16333 10.1415 4.5396 8.66789 6.28332 7.6377C8.03511 6.60278 10.2185 5.97664 12.4982 5.97656ZM12.4982 7.57617C10.5026 7.57625 8.60015 8.1265 7.09679 9.01465C5.58531 9.90763 4.53672 11.1045 4.13683 12.3604C4.13651 12.3614 4.13602 12.3626 4.13585 12.3633C4.70504 13.8806 7.12813 16.9764 12.4982 16.9766C17.9325 16.9766 20.3163 14.1228 20.8595 12.4092L20.8566 12.3975C19.8773 9.79587 16.5276 7.57617 12.4982 7.57617ZM12.4991 8.47656C14.5978 8.47656 16.2988 10.1778 16.2989 12.2764C16.2989 14.375 14.5978 16.0762 12.4991 16.0762C10.4005 16.0761 8.69933 14.375 8.69933 12.2764C8.69944 10.1778 10.4006 8.47667 12.4991 8.47656ZM12.4991 10.0762C11.2843 10.0763 10.299 11.0615 10.2989 12.2764C10.2989 13.4913 11.2842 14.4765 12.4991 14.4766C13.7142 14.4766 14.6993 13.4914 14.6993 12.2764C14.6992 11.0614 13.7141 10.0762 12.4991 10.0762Z" fill="white"/>
                  </svg>
                  <span style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '1.2',
                    color: 'white',
                    letterSpacing: '-0.36px',
                    marginLeft: '8px'
                  }}>
                    미리보기
                  </span>
                </PreviewButton>
              </PreviewOverlay>
            </ConceptPreview>
          </ConceptCard>
        ))}
      </ConceptGrid>
      {previewConcept && (
        <OrganismDisplayViewInfoPreview
          onClose={handleClosePreview}
          contentsDesignConcept={previewConcept.id}
          titleData={
            titleData
          }
          markdownData={
            markdownData
          }
          template={{ category: getConceptName(previewConcept.id) }}
          title={getConceptName(previewConcept.id)}
          displayWidth={"3840"}
          displayHeight={"2160"}
          contentsType={contentsType}
          linkUrl={linkUrl}
          logo={logo}
        />
      )}
    </ConceptSelectorWrapper>
  );
};

export default OrganismDesignConceptSelector;

const ConceptSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ConceptGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

const ConceptCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  border: 1px solid
    ${(props) => {
      if (props.disabled) return "#E0E4EB";
      return props.selected ? palette.primary : "#E0E4EB";
    }};
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  background: ${(props) => {
    if (props.disabled) return "#F8F9FA";
    return props.selected ? "rgba(34, 111, 255, 0.05)" : "white";
  }};
  position: relative;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};
  overflow: hidden;

  &:hover {
    border-color: ${(props) => (props.disabled ? "#E0E4EB" : palette.primary)};
    background: ${(props) =>
      props.disabled ? "#F8F9FA" : "rgba(34, 111, 255, 0.02)"};
  }
`;

const ConceptHeader = styled.div`
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 12px;
  padding-bottom: 12px;
  background: #f8f8f9;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px rgba(179, 183, 186, 0.5) solid;
  justify-content: flex-start;
  align-items: left;
  gap: 10px;
  display: flex;
`;

const LeftAlignedCheckBox = styled.input.attrs({ type: "checkbox" })`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: 0 !important;
  border-radius: 50%;
  cursor: pointer;
  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' fill='%23ffffff' stroke='%23B3B7BA'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const ConceptPreview = styled.div`
  width: 100%;
  flex: 1;
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  
  &:hover {
    .preview-overlay {
      opacity: 1;
    }
  }
`;

// 스타일드 컴포넌트 추가
const PreviewImage = styled.img`
  width: 100%;
  height: 146px;
  object-fit: cover;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const ConceptName = styled.span`
  color: #090f15;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  margin-left: 12px;
`;

const PreviewOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.3s ease;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

const PreviewButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid white;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }
`;
